import React, { useRef, useState } from 'react'
import { FadedAnimatedDiv } from 'components'
import Searching from 'pages/contacts/Searching'
import CustomModal from 'components/Modal'
import { deleteUser, getUsers } from 'store/actions/usersActions'
import NewSalesRep from './new'
import { isMobile } from 'react-device-detect'

const LoadingContacts = () => (
  <FadedAnimatedDiv className='h-full w-full flex flex-col items-center mt-20'>
    <Searching title='Loading Sales Reps...' />
  </FadedAnimatedDiv>
)

const SalesReps = () => {
  const mountedRef = useRef(true)
  const [isLoading, setIsLoading] = useState(true)
  const [salesReps, setSalesReps] = useState([])
  const [sortByName, setSortByName] = useState('')
  const [viewMode, setViewMode] = useState('list')
  const [selectedSalesRep, setSelectedSalesRep] = useState('')
  const [isShowDeleteModal, setIsShowDeleteModal] = useState(false)
  const userTypeFilter = '?userType=SalesRep'

  React.useEffect(() => {
    getUsers('', userTypeFilter).then((users) => {
      if (!mountedRef.current) return null
      setSalesReps(users)
      setIsLoading(false)
    })
    return () => {
      mountedRef.current = false
    }
  }, [])

  const updateSalesReps = () => {
    setIsLoading(true)
    getUsers('', userTypeFilter).then((users) => {
      setSalesReps(users)
      setIsLoading(false)
    })
  }

  const sortedSalesReps = salesReps.sort((a, b) => {
    if (sortByName === 'asc') return a.firstName.localeCompare(b.firstName)
    if (sortByName === 'desc') return b.firstName.localeCompare(a.firstName)
    return 0
  })

  const selectedUser = sortedSalesReps.find((user) => user.id === selectedSalesRep)

  const SalesRepList = () => (
    <>
      <div className='p-6 flex justify-between items-center'>
        <span className='font-bold text-3xl'>Sales Reps</span>
        <button className='cursor-pointer hover:text-yellow-400' onClick={() => setViewMode('new')}>
          <span className='text-2xl mr-2'>+</span>Add Sales Rep
        </button>
      </div>
      <div className='border-b-2 border-black' />
      <div className='w-full overflow-auto'>
        <div className='p-6 grid grid-cols-3 text-xs bg-inherit' style={{ width: isMobile ? '1300px' : undefined }}>
          <span className='flex items-center space-x-2'>
            <span className='leading-none'>NAME</span>
            <button onClick={() => setSortByName((prev) => (prev === 'asc' ? 'desc' : 'asc'))}>
              <svg
                width='12'
                height='12'
                viewBox='0 0 12 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M4.98484 8.73482L4.12502 9.59466V1.5C4.12502 1.40054 4.08552 1.30516 4.01519 1.23483C3.94486 1.16451 3.84948 1.125 3.75002 1.125C3.65057 1.125 3.55519 1.16451 3.48486 1.23483C3.41453 1.30516 3.37502 1.40054 3.37502 1.5V9.59466L2.51521 8.73482C2.44488 8.66449 2.34949 8.62497 2.25002 8.62497C2.15056 8.62497 2.05517 8.66449 1.98484 8.73482C1.91451 8.80515 1.875 8.90054 1.875 9C1.875 9.09946 1.91451 9.19485 1.98484 9.26518L3.48484 10.7652C3.48663 10.7669 3.48857 10.7684 3.49038 10.7702C3.49745 10.777 3.50462 10.7837 3.51222 10.7899C3.51704 10.7939 3.5221 10.7973 3.52709 10.801C3.53192 10.8046 3.53666 10.8084 3.54167 10.8118C3.54735 10.8156 3.55323 10.8189 3.55907 10.8223C3.56376 10.8251 3.56831 10.8281 3.57314 10.8306C3.57896 10.8338 3.58493 10.8364 3.59088 10.8392C3.59605 10.8416 3.60114 10.8442 3.60644 10.8464C3.61214 10.8488 3.61798 10.8507 3.62379 10.8528C3.62954 10.8548 3.63521 10.857 3.64107 10.8588C3.64686 10.8606 3.65275 10.8618 3.6586 10.8633C3.66462 10.8648 3.67058 10.8665 3.67671 10.8677C3.68337 10.869 3.6901 10.8698 3.69681 10.8708C3.70223 10.8716 3.70754 10.8726 3.71301 10.8731C3.7253 10.8743 3.73766 10.875 3.75002 10.875C3.76238 10.875 3.77474 10.8743 3.78703 10.8731C3.7925 10.8726 3.79781 10.8716 3.80324 10.8708C3.80994 10.8698 3.81667 10.869 3.82333 10.8677C3.82947 10.8665 3.83542 10.8648 3.84144 10.8633C3.8473 10.8618 3.85318 10.8606 3.85897 10.8588C3.86483 10.857 3.8705 10.8548 3.87625 10.8528C3.88206 10.8507 3.8879 10.8488 3.8936 10.8464C3.89891 10.8442 3.90399 10.8416 3.90916 10.8392C3.91511 10.8364 3.92108 10.8338 3.9269 10.8306C3.93173 10.8281 3.93628 10.8251 3.94097 10.8223C3.94681 10.8189 3.95269 10.8156 3.95837 10.8118C3.96338 10.8084 3.96812 10.8046 3.97295 10.801C3.97794 10.7973 3.98299 10.7939 3.98782 10.7899C3.99542 10.7837 4.00259 10.777 4.00966 10.7702C4.01147 10.7684 4.01341 10.7669 4.0152 10.7652L5.5152 9.26518C5.58553 9.19485 5.62504 9.09946 5.62504 9C5.62504 8.90054 5.58553 8.80515 5.5152 8.73482C5.44487 8.66449 5.34948 8.62497 5.25002 8.62497C5.15055 8.62497 5.05516 8.66449 4.98483 8.73482H4.98484Z'
                  fill='#2E2B2E'
                  fillOpacity='0.7'
                />
                <path
                  d='M10.0152 2.73476L8.5152 1.23476C8.51355 1.23314 8.51177 1.23176 8.5101 1.23016C8.50289 1.22322 8.49556 1.2164 8.48783 1.21004C8.48302 1.2061 8.47798 1.20265 8.47304 1.19899C8.46814 1.19535 8.46341 1.19157 8.45835 1.18818C8.45272 1.18441 8.4469 1.18116 8.44114 1.17772C8.43638 1.17491 8.43175 1.17191 8.42688 1.1693C8.42113 1.16621 8.41523 1.1636 8.40935 1.16085C8.4041 1.15838 8.39893 1.15575 8.39355 1.15353C8.38792 1.1512 8.38218 1.14932 8.37646 1.14728C8.37064 1.14518 8.36487 1.14293 8.35892 1.14112C8.3532 1.13941 8.34741 1.13812 8.34162 1.13668C8.33553 1.13515 8.32951 1.13343 8.32331 1.13222C8.31672 1.13089 8.31004 1.13012 8.30337 1.12918C8.29793 1.1284 8.29255 1.12735 8.28703 1.12682C8.26242 1.12439 8.23763 1.12439 8.21301 1.12682C8.2075 1.12735 8.20212 1.1284 8.19667 1.12918C8.19001 1.13011 8.18333 1.13089 8.17673 1.13222C8.17053 1.13343 8.16451 1.13515 8.15842 1.13668C8.15263 1.13813 8.14684 1.13941 8.14112 1.14112C8.13517 1.14293 8.1294 1.14518 8.12359 1.14728C8.11787 1.14932 8.11212 1.1512 8.10649 1.15353C8.10111 1.15575 8.09594 1.15838 8.0907 1.16085C8.08482 1.1636 8.07891 1.16621 8.07317 1.1693C8.06829 1.17191 8.06367 1.17491 8.05891 1.17772C8.05314 1.18116 8.04733 1.18441 8.0417 1.18818C8.03664 1.19157 8.0319 1.19535 8.027 1.19899C8.02206 1.20265 8.01702 1.2061 8.01222 1.21004C8.00448 1.2164 7.99716 1.22322 7.98995 1.23016C7.98828 1.23176 7.98649 1.23314 7.98484 1.23476L6.48484 2.73476C6.45002 2.76958 6.42239 2.81093 6.40355 2.85643C6.3847 2.90193 6.375 2.95069 6.375 2.99994C6.375 3.04919 6.3847 3.09796 6.40355 3.14346C6.42239 3.18896 6.45002 3.2303 6.48484 3.26513C6.55517 3.33546 6.65056 3.37497 6.75003 3.37497C6.79927 3.37497 6.84804 3.36527 6.89354 3.34642C6.93904 3.32757 6.98038 3.29995 7.01521 3.26513L7.87502 2.40529V10.4999C7.87502 10.5994 7.91453 10.6948 7.98485 10.7651C8.05518 10.8354 8.15056 10.8749 8.25002 10.8749C8.34948 10.8749 8.44486 10.8354 8.51519 10.7651C8.58551 10.6948 8.62502 10.5994 8.62502 10.4999V2.40529L9.48484 3.26513C9.51966 3.29995 9.561 3.32758 9.6065 3.34642C9.652 3.36527 9.70077 3.37497 9.75002 3.37497C9.79927 3.37497 9.84804 3.36527 9.89354 3.34642C9.93904 3.32758 9.98038 3.29995 10.0152 3.26513C10.05 3.2303 10.0777 3.18896 10.0965 3.14346C10.1153 3.09796 10.125 3.04919 10.125 2.99994C10.125 2.9507 10.1153 2.90193 10.0965 2.85643C10.0777 2.81093 10.05 2.76959 10.0152 2.73476V2.73476Z'
                  fill='#2E2B2E'
                  fillOpacity='0.7'
                />
              </svg>
            </button>
          </span>
          <span>EMAIL</span>
          <span>DEVELOPER COMPANY</span>
        </div>
        <div className='px-6 bg-inherit' style={{ width: isMobile ? '1300px' : undefined }}>
          {isLoading && <LoadingContacts />}
          {!isLoading &&
            sortedSalesReps.map(({ id, firstName, lastName, email, salesRepData, imgsrc }) => (
              <div
                className='relative group grid grid-cols-3 font-semibold items-center py-4 border-b text-base border-gray-700'
                key={id}>
                <span className='flex items-center space-x-4'>
                  {imgsrc && (
                    <img src={imgsrc} alt='Avatar' className='h-12 w-12 border rounded-full' />
                  )}
                  {!imgsrc && (
                    <div className='h-12 w-12 border rounded-full flex items-center justify-center bg-gray-200 text-text-gray-500 font-bold'>
                      {firstName[0]}
                      {lastName[0]}
                    </div>
                  )}
                  <span>
                    {firstName} {lastName}
                  </span>
                </span>
                <span>{email}</span>
                <span>{salesRepData?.developerCompany?.companyName || ''}</span>
                <span className='absolute right-0 group-hover:block hidden'>
                  <button className='px-6'>
                    <svg
                      width='19'
                      height='19'
                      viewBox='0 0 19 19'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M0 15.4596V18.4996C0 18.7796 0.22 18.9996 0.5 18.9996H3.54C3.67 18.9996 3.8 18.9496 3.89 18.8496L14.81 7.93957L11.06 4.18957L0.15 15.0996C0.0500001 15.1996 0 15.3196 0 15.4596ZM17.71 5.03957C18.1 4.64957 18.1 4.01957 17.71 3.62957L15.37 1.28957C14.98 0.89957 14.35 0.89957 13.96 1.28957L12.13 3.11957L15.88 6.86957L17.71 5.03957Z'
                        fill='#2E2B2E'
                        fillOpacity='0.7'
                      />
                    </svg>
                  </button>
                  <button
                    onClick={() => {
                      setSelectedSalesRep(id)
                      setIsShowDeleteModal(true)
                    }}>
                    <svg
                      width='14'
                      height='18'
                      viewBox='0 0 14 18'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V6C13 4.9 12.1 4 11 4H3C1.9 4 1 4.9 1 6V16ZM13 1H10.5L9.79 0.29C9.61 0.11 9.35 0 9.09 0H4.91C4.65 0 4.39 0.11 4.21 0.29L3.5 1H1C0.45 1 0 1.45 0 2C0 2.55 0.45 3 1 3H13C13.55 3 14 2.55 14 2C14 1.45 13.55 1 13 1Z'
                        fill='#2E2B2E'
                        fillOpacity='0.7'
                      />
                    </svg>
                  </button>
                </span>
              </div>
            ))}
        </div>
      </div>
    </>
  )

  return (
    <div className='bg-gray-100 min-h-screen'>
      {viewMode === 'list' && <SalesRepList />}
      {viewMode === 'new' && (
        <NewSalesRep cancel={() => setViewMode('list')} update={updateSalesReps} />
      )}
      <CustomModal isOpen={isShowDeleteModal} closeModal={() => setIsShowDeleteModal(false)}>
        <div className='py-10 px-20 flex flex-col items-center'>
          <h1 className='font-bold text-black'>Delete Coop Broker</h1>
          <p className='py-2'>
            Are you sure you want to delete
            <strong className='ml-1'>
              {selectedUser?.firstName} {selectedUser?.lastName}
            </strong>
            ?
          </p>
          <div className='flex font-semibold space-x-4'>
            <button
              onClick={() => setIsShowDeleteModal(false)}
              className='w-28 border border-black py-2 rounded'>
              Cancel
            </button>
            <button
              onClick={async () => {
                deleteUser(selectedSalesRep).then(() => updateSalesReps())
                setIsShowDeleteModal(false)
              }}
              className='w-28 rounded bg-volt py-2'>
              Delete
            </button>
          </div>
        </div>
      </CustomModal>
    </div>
  )
}

export default SalesReps
